import styled from '@emotion/styled';
import { Dialog, type DialogProps } from '@mui/material';
import mediaQuery from '@/lib/styling/mediaQuery';
import stripProps from '@/lib/utils/stripProps';

type DialogWithDangerousHandlingProps = DialogProps & {
  dangerous?: boolean;
};

const DialogWithDangerousHandling = styled(
  stripProps(Dialog, 'dangerous') as typeof Dialog,
)<DialogWithDangerousHandlingProps>(
  {
    '.MuiDialog-container': {
      [mediaQuery(640)]: {
        alignItems: 'flex-end !important',
      },
    },
  },
  ({ theme, dangerous }) => {
    if (theme.palette.isHighContrast || !dangerous) {
      return null;
    }

    return {
      '.MuiDialog-container > .MuiPaper-root': {
        borderLeft: `8px solid ${theme.palette.error.main}`,
        boxSizing: 'border-box',
        [mediaQuery(640)]: {
          borderTop: `8px solid ${theme.palette.error.main}`,
          borderLeft: 'none',
        },
      },
    };
  },
);

export default DialogWithDangerousHandling;
